import React, { ComponentPropsWithRef, ReactElement } from 'react';
import classnames from 'classnames';
import { FormGroup, FormGroupText } from '../FormGroup';

export type TextfieldProps = ComponentPropsWithRef<'input'> & {
  error?: string;
  horizontal?: boolean;
  label?: string;
  labelClass?: string;
  required?: boolean;
};

export function Textfield({
  className,
  error,
  horizontal = true,
  id,
  label,
  labelClass,
  required,
  ...rest
}: TextfieldProps): ReactElement {
  const classes = classnames({ error });

  return (
    <FormGroup
      horizontal={horizontal}
      errors={error ? [error] : []}
      className={className}
    >
      <FormGroupText>
        <label className={labelClass} htmlFor={id}>
          {label} {required && '*'}
        </label>
        <input id={id} type="text" className={classes} {...rest} />
      </FormGroupText>
    </FormGroup>
  );
}
